import m from 'mithril';
import dayjs from 'dayjs';
import { MultipleMonthView } from './MultipleMonthView';
import './DateRangePicker.scss';

interface Attrs {
    startYear: number,
    startMonth: number,
    selectedDateRange?: DateRange|null,
    startLabel?:string,
    endLabel?:string,
    applyButtonLabel?:string,
    minDate?: string, 
    maxRange: number,
    numberOfMonth?: number,
    isOnDesktop?: boolean,
    onDateRangeSelected: (startDate:string, endDate:string) => void
}

interface DateRange {
    startDate: string,
    endDate: string
}

export default function DateRangePicker(): m.Component<Attrs> {
    let selectionStartDate:string|null = null;
    let selectionEndDate:string|null = null;    

    return {
        oninit(vnode) {
            if(vnode.attrs.selectedDateRange) {
                selectionStartDate = vnode.attrs.selectedDateRange.startDate;
                selectionEndDate = vnode.attrs.selectedDateRange.endDate;
            }
        },

        view(vnode) {
            const {startYear, startMonth, startLabel, endLabel, applyButtonLabel, minDate, maxRange, numberOfMonth, isOnDesktop, 
                onDateRangeSelected } = vnode.attrs;

            return m("div.pt-3", [
                m(MultipleMonthView, {
                    startYear: startYear, 
                    startMonth: startMonth, 
                    numberOfMonths: (numberOfMonth != undefined)?  numberOfMonth: 12,
                    selectionStartDate: selectionStartDate,
                    selectionEndDate: selectionEndDate,
                    minDate: minDate,
                    maxRange: maxRange,             
                    isOnDesktop: isOnDesktop,
                    onDateClicked : (date:string) => {                        
                        if(selectionStartDate == undefined) {
                            selectionStartDate = date;
                            selectionEndDate = null;
                        } else {
                            if(dayjs(date).diff(selectionStartDate, 'day') > maxRange) {
                                selectionStartDate = date;
                                selectionEndDate = null;
                            } else if(dayjs(date).isAfter(selectionStartDate) && selectionEndDate == null) {
                                selectionEndDate = date;                                       
                            } else {
                                selectionStartDate = date;
                                selectionEndDate = null;
                            }
                        }
                        console.log("date range", selectionStartDate, selectionEndDate);
                    }
                }),
                
                m("div.fixed-bottom", 
                    m("div.card shadow-lg", 
                        m("div.card-body", 
                            [
                                m("div.row mb-3", [
                                    m("div.col-5 text-right date-area", [
                                        m(SmallLabel, {label: (startLabel)? startLabel: "Start Date"}),
                                        
                                        (selectionStartDate)?
                                        [
                                            m("a.mr-2 date-clear-btn", {
                                                href:"#",
                                                onclick: (event) => {
                                                    event.preventDefault();
                                                    selectionStartDate = null;
                                                    selectionEndDate = null;
                                                }
                                            }, m.trust("&times;")),
                                            m("span.font-weight-bold text-primary", dayjs(selectionStartDate).format("MMM D, YYYY")) 
                                        ]
                                        : m("div.text-muted", "----------")
                                    ]),
                                    m("div.col-2 text-center mt-3", m("i.bi bi-arrow-right text-primary")),
                                    m("div.col-5 text-left date-area", [
                                        m(SmallLabel, {label: (endLabel)? endLabel: "End Date"}),

                                        (selectionEndDate)?
                                        [
                                            m("span.font-weight-bold text-primary", dayjs(selectionEndDate).format("MMM D, YYYY")),
                                            m("a.ml-2 date-clear-btn", {
                                                href:"#",
                                                onclick: (event) => {
                                                    event.preventDefault();
                                                    selectionEndDate = null;
                                                }
                                            }, m.trust("&times;"))
                                        ]
                                        : m("div.text-muted", "-----------")
                                    ])
                                ]),
                                m("div.row", 
                                    m("div.col", 
                                        m("button", {
                                            class: (selectionStartDate && selectionEndDate)? 
                                                "btn btn-block btn-primary pt-2 pb-2 rounded" : "btn btn-block btn-primary disabled pt-2 pb-2 rounded",
                                            onclick: (event) => {
                                                if(selectionStartDate && selectionEndDate) {
                                                    onDateRangeSelected(selectionStartDate, selectionEndDate);
                                                }                                                
                                            }
                                        }, (applyButtonLabel)? applyButtonLabel: "Apply Date Range")
                                    )
                                )
                            ]
                        )
                    )
                )                            
            ]);
        }
    }
}

function SmallLabel(): m.Component<{label:string}> {
    return {
        view(vnode) {
            return m("div", 
                m("small.text-quiet", vnode.attrs.label)
            );
        }
    }
}